/* @flow */
import Collection from 'lib/Collection';
import naturalSort from 'javascript-natural-sort';
import Widget from 'entities/Widget';

class Widgets extends Collection {
  initialize() {
    this.model = Widget;
    this.url = '/widgets';
  }

  comparator(a: Widget, b: Widget) {
    if (a.isAllClassesWidget()) {
      return -1;
    }

    if (b.isAllClassesWidget()) {
      return 1;
    }

    return naturalSort(a.getClassName().toLowerCase(), b.getClassName().toLowerCase());
  }
}

export default Widgets;



// WEBPACK FOOTER //
// ./src/collections/Widgets.js